import { render } from "./SegmentDateInput.vue?vue&type=template&id=5e38b965&scoped=true"
import script from "./SegmentDateInput.vue?vue&type=script&lang=ts"
export * from "./SegmentDateInput.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5e38b965"

export default script